<script>
  import {mapState, mapActions, mapGetters} from 'vuex'
  import axios from 'axios'

  export default {
    props: {
    },
    data() {
      return {
        onlineCashes: [],
        isOnlineCashboxesBlocked: false,
        shiftLoadingStarted: false,
      }
    },
    methods: {
      ...mapActions('user', {
        promptNoFeature: 'promptNoFeature',
      }),
      wrapperClick(){
        if (this.isOnlineCashboxesBlocked){
          this.promptNoFeature('Работа с онлайн кассами недоступна для Вашего тарифного плана. Перейти к управлению тарифами?');
        }
      },
      openShift(cashId) {
        this.processCashOperation(cashId, "open");
      },
      closeShift(cashId) {
        this.processCashOperation(cashId, "close");
      },
      printXReport(cashId) {
        this.processCashOperation(cashId, "xreport");
      },
      processCashOperation(cashId, operation) {
        axios.post("/tourclient/api/onlinecash/shift/" + operation + "?cashId=" + cashId, {cashId: cashId}).then(stateResp => {
          if (stateResp.data.OperationStatusId === 1) {
            this.getShiftState(cashId, stateResp.data.CheckOperationId, true);
          } else if (stateResp.data.OperationStatusId === 2) {
            this.getShiftState(cashId, null, false);
          } else if (stateResp.data.ResultQueryInfo.UserMessages.length) {
            window.app.$notify.error({
              message: stateResp.data.ResultQueryInfo.UserMessages
            });
          } else {
            window.app.$notify.error({
              message: 'Ошибка при выполнении операции с кассой'
            });
          }
        }).catch(resp => {
          window.app.$notify.error({
            message: 'Ошибка при выполнении операции с кассой'
          });
        });
      },
      getShiftState(cashId, operationId, isShiftOperationActionRequest) {
        // console.log('get shift state ' + cashId);

        let currentCash = null;
        for (let cash of this.onlineCashes) {
          if (cash.Id === +cashId) {
            currentCash = cash;
            break;
          }
        }
        currentCash.waitOperation = true;
        currentCash.loadingError = false;

        let url = '/tourclient/api/onlinecash/shift/status/' + cashId;

        if (operationId) {
          url += '/' + operationId;
          url += '?isShiftOperationActionRequest=' + (isShiftOperationActionRequest ? 'true' : 'false');
        }

        let axiosPromise = axios.get(url);
        axiosPromise.then(stateResp => {
          // console.log(stateResp);

          if (stateResp.data.OperationStatusId === 2) {
            if (isShiftOperationActionRequest) {
              console.log(stateResp.data);
              this.getShiftState(cashId, null, false);
            } else {
              currentCash.waitOperation = false;

              let status = stateResp.data.Status;

              switch (status.Type) {
                case 1:
                  currentCash.ShiftState = "Открыта (истекает " + status.ExpiredTime.Serialized + ")";
                  break;
                case 2:
                  currentCash.ShiftState = "Закрыта";
                  break;
                case 3:
                  currentCash.ShiftState = "Истекла " + status.ExpiredTime.Serialized;
                  break;
                default:
                  currentCash.ShiftState = "-";
                  break;
              }
            }
          } else if (stateResp.data.OperationStatusId === 1) {
            if (operationId && operationId !== stateResp.data.CheckOperationId) {
              isShiftOperationActionRequest = false;
            }
            setTimeout(() => {
              this.getShiftState(cashId, stateResp.data.CheckOperationId, isShiftOperationActionRequest);
            }, 1000);
          } else if (stateResp.data.ResultQueryInfo.UserMessages.length) {
            let messageFromCash = stateResp.data.ResultQueryInfo.UserMessages;
            currentCash.waitOperation = false;
            currentCash.loadingError = true;
            currentCash.ShiftState = messageFromCash;
            window.app.$notify.error({
              message: messageFromCash
            });
          } else {
            currentCash.waitOperation = false;
            currentCash.loadingError = true;
            currentCash.ShiftState = 'Ошибка при выполнении операции с кассой';
            window.app.$notify.error({
              message: 'Ошибка при выполнении операции с кассой'
            });
          }
        });

        axiosPromise.catch(resp => {
          currentCash.waitOperation = false;
          currentCash.loadingError = true;
          currentCash.ShiftState = 'Ошибка при выполнении операции с кассой';
          window.app.$notify.error({
            message: 'Ошибка при выполнении операции с кассой'
          });
        });
      },
      loadShiftStates() {
        if (this.shiftLoadingStarted) {
          return;
        }

        this.shiftLoadingStarted = true;

        for (let cash of this.onlineCashes) {
          if (cash.Capabilities.CanGetShiftState) {
            this.getShiftState(cash.Id, null, false);
          }
        }
      }
    },
    computed: {
      ...mapGetters({
        permission: 'permission',
      }),
      ...mapGetters('user', {
        hasFeature: 'hasFeature',
      })
    },
    watch: {},
    mounted() {
      if (!this.hasFeature([8])){
        this.isOnlineCashboxesBlocked = true;

        return;
      }

      axios.get('/tourclient/Settings/OnlineCashSettingsList').then(resp => {
        for (let cash of resp.data.OnlineCashes) {
          cash.ShiftState = '';
          cash.waitOperation = false;
          if (cash.Capabilities.CanManageShift && cash.IsActive) {
            this.onlineCashes.push(cash);
          }
        }
      });
    },

    components: {},
  }
</script>
<template>
  <div>
    <el-popover v-if="onlineCashes && onlineCashes.length"
                placement="bottom"
                title="Управление кассами"
                width="765"
                trigger="click"
                @show="loadShiftStates"
                :disabled="isOnlineCashboxesBlocked">
      <el-table :data="onlineCashes" v-if="!isOnlineCashboxesBlocked">
        <el-table-column width="200" property="Name" label="Касса"></el-table-column>
        <el-table-column width="170" property="ShiftState" label="Состояние смены">
          <template slot-scope="scope">
            <div v-bind:style="{color: scope.row.loadingError ? 'red' : 'black'}">
              {{scope.row.ShiftState}}
            </div>
          </template>
        </el-table-column>
        <el-table-column width="360" label="Управление">
          <template slot-scope="scope">
            <div v-if="!scope.row.loadingError">
              <el-button @click="openShift(scope.row.Id)" v-loading="scope.row.waitOperation" v-if="permission(281)"
                         type="primary" size="small">Открыть смену
              </el-button>
              <el-button @click="closeShift(scope.row.Id)" v-loading="scope.row.waitOperation" v-if="permission(282)"
                         type="primary" size="small">Закрыть смену
              </el-button>
              <el-button @click="printXReport(scope.row.Id)" v-loading="scope.row.waitOperation"
                         v-if="scope.row.Capabilities.CanPrintXReport && permission(283)" type="primary" size="small">
                X-отчет
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div style="display: inline-block;" slot="reference" @click="wrapperClick">
        <el-button type="primary" :disabled="isOnlineCashboxesBlocked">Онлайн кассы</el-button>
      </div>
    </el-popover>
  </div>


  <!--<form-group class="dictionary dictionary-payment-operation" :label-width="labelWidth" :append="append" :label="label">-->
  <!--<el-select-->
  <!--:value="value"-->
  <!--@change="change_value"-->
  <!--@input="input_value"-->
  <!--:disabled="disabled"-->
  <!--:filterable="filterable"-->
  <!--:multiple="multiple"-->
  <!--:collapse-tags="multiple"-->
  <!--:clearable="clearable">-->
  <!--<el-option :value="0" label="Выбрать">-->
  <!--</el-option>-->
  <!--<el-option v-for="item in list"-->
  <!--:value="item.value"-->
  <!--:label="item.label"-->
  <!--:key="item.value">-->
  <!--</el-option>-->
  <!--</el-select>-->
  <!--<el-button-->
  <!--v-if="show_remove"-->
  <!--slot="append"-->
  <!--icon="el-icon-close"-->
  <!--title="Очистить"-->
  <!--@click="change_value([])">-->
  <!--</el-button>-->
  <!--<el-button-->
  <!--v-if="show_add"-->
  <!--slot="append"-->
  <!--icon="el-icon-plus"-->
  <!--title="Добавить"-->
  <!--@click="item_add">-->
  <!--</el-button>-->
  <!--</form-group>-->
</template>
<style lang="scss">
</style>
